var map = {
	"./customers.png": 73108,
	"./dashboard.png": 13941,
	"./inventory.png": 11402,
	"./logout.png": 1506,
	"./marketing.png": 71992,
	"./reservations.png": 86695,
	"./scheduler.png": 290,
	"./settings.png": 34737,
	"./walk-up-order.png": 9314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28889;